import { BillingEventsResponse } from '../models/BillingModel'
import { HttpClient } from '../../data/protocols/http/httpClient'

export interface GetBillingEvents {
  getBillingEvents: (billingId: string) => Promise<BillingEventsResponse>
}

export class RemoteGetBillingEvents implements GetBillingEvents {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async getBillingEvents(billingId: string): Promise<BillingEventsResponse> {
    const httpResponse = await this.httpClient.get!({
      url: `${this.url}/${billingId}/events`
    })
    return httpResponse
  }
}
